import { CloseIcon, MenuIcon } from '~components/icons'
import useBreakpoint from '~hooks/use-breakpoint'
import { AppBar, Box, IconButton, Toolbar } from '@mui/material'
import { useEffect } from 'react'
import { Link, useLocation, useMatch } from 'react-router-dom'
import { PageRoute } from 'src/routes/routes-behind-login/page-route'
import { OPEN_DRAWER_WIDTH } from '~hooks/use-nav-and-footer-constants'
import { COLORS } from '~theme/colors'
import { LeftNavigation } from './left-navigation'
import {
  breakpointsWithHamburgerMenu,
  useNavigation,
} from './navigation-context'

export const MENU_Z_INDEX = 1401

export function Navigation() {
  const {
    isOpen: isMenuOpen,
    setIsOpen: setIsMenuOpen,
    setNavigationVariant,
  } = useNavigation()
  const { breakpoint } = useBreakpoint()
  const location = useLocation()
  const isHamburger = breakpointsWithHamburgerMenu.includes(breakpoint)

  useEffect(() => {
    if (isHamburger && isMenuOpen) {
      setIsMenuOpen(false)
    }
  }, [location])

  useNoScrollWhenHamburgerOpen(isHamburger && isMenuOpen)

  const handleDrawerOpen = () => {
    setIsMenuOpen(true)
  }
  const handleDrawerClose = () => {
    setIsMenuOpen(false)
  }

  const isFinancialEarningsChildRoute = !!useMatch(
    `${PageRoute.VESSEL_FINANCIALS}/*`,
  )

  const isVesselFleetChildRoute = !!useMatch(
    `${PageRoute.FLEET}/${PageRoute.FLEET_VESSELS}/:child/*`,
  )

  useEffect(() => {
    if (isFinancialEarningsChildRoute || isVesselFleetChildRoute) {
      setNavigationVariant('secondary')
    } else {
      setNavigationVariant('primary')
    }
  }, [isFinancialEarningsChildRoute, isVesselFleetChildRoute])

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        sx={getAppBarStyles(isMenuOpen, isHamburger)}
        {...(isHamburger && { 'data-tour-sticky-header': true })}
      >
        {isHamburger && (
          <Toolbar sx={{ height: '100%' }}>
            <IconButton
              className="tour-step-nav-hamburger"
              aria-label={
                isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'
              }
              onClick={isMenuOpen ? handleDrawerClose : handleDrawerOpen}
            >
              {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
            <Box component={Link} to="/" sx={{ width: '100%' }}>
              <img
                src="/base-logo.svg"
                alt="Maersk Logo"
                style={{ width: '100%', height: 24 }}
              />
            </Box>
          </Toolbar>
        )}
      </AppBar>
      <LeftNavigation />
    </Box>
  )
}

function getAppBarStyles(open: boolean, isHamburger: boolean) {
  return {
    zIndex: MENU_Z_INDEX,
    backgroundColor: isHamburger ? COLORS.greys.ultraLight : 'transparent',
    ...(open && {
      marginLeft: OPEN_DRAWER_WIDTH,
    }),
    ...(isHamburger && {
      height: '64px',
    }),
    ...(!isHamburger && {
      boxShadow: 'none',
    }),
  }
}

function useNoScrollWhenHamburgerOpen(shouldLock: boolean) {
  useEffect(() => {
    if (shouldLock) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [shouldLock])
}
